export const FIVE_LEVEL_EXPERIENCE = {
  I: "1-3 years",
  II: "3-5 years",
  III: "5-7 years",
  IV: "7-10 years",
  V: "10+ years",
};

export const THREE_LEVEL_EXPERIENCE = {
  I: "1-5 years",
  II: "5-10 years",
  III: "10+ years",
};

type ExperienceLevel = {
  levelRomanNumeral?: string | null;
};

type ExperienceSearch = {
  showThreeLevelsView?: boolean;
  resultsByLevel?: Record<string, ExperienceLevel | null | undefined>;
};

export function hasThreeExperienceLevels(
  romanNumerals: Array<string | null | undefined>
): boolean {
  const levels = new Set(romanNumerals);
  return levels.size === 3 && ["I", "II", "III"].every((level) => levels.has(level));
}

export function getExperienceBands(isThreeLevel: boolean): Record<string, string> {
  return isThreeLevel ? THREE_LEVEL_EXPERIENCE : FIVE_LEVEL_EXPERIENCE;
}

export function usesThreeLevelBands(
  search: ExperienceSearch,
  isThreeLevelClient: boolean = false
): boolean {
  if (search.showThreeLevelsView) return true;
  const levels = Object.values(search.resultsByLevel || {}).filter(
    (level): level is ExperienceLevel => Boolean(level)
  );
  return levels.length
    ? hasThreeExperienceLevels(levels.map((level) => level.levelRomanNumeral))
    : Boolean(isThreeLevelClient);
}

export function getSearchExperienceModes(
  searches: ExperienceSearch[],
  isThreeLevelClient: boolean = false
): boolean[] {
  const loadedSearches = searches.filter(
    (search) =>
      search.showThreeLevelsView ||
      Object.values(search.resultsByLevel || {}).some(Boolean)
  );
  return loadedSearches.length
    ? Array.from(new Set(loadedSearches.map((search) => usesThreeLevelBands(search))))
    : [Boolean(isThreeLevelClient)];
}
